import React, { createContext, useState } from 'react';

type Context = {
    open: boolean;
    openPopup: Function;
};

export const PopupContext = createContext<Context>({
    open: false,
    openPopup: () => false,
});

const PopupProvider: React.FC = (props) => {
    const [open, setOpen] = useState(false);
    const openPopup = (value: boolean): void => {
        setOpen(value);
    };
    return <PopupContext.Provider value={{ open, openPopup }}>{props.children}</PopupContext.Provider>;
};
export { PopupProvider };
